<template>
	<div class="keywordwarninginfo">
		<div v-if="jingpin">
			<van-tabs v-model="activeName" color='#333333' line-width="48px" style="border-bottom: 1px solid #eeeeee;" v-if="ES_tabs" @click="onClick">
				<van-tab title="ES论坛" name='雷克萨斯ES论坛'></van-tab>
				<van-tab title="3系论坛" name='宝马3系论坛'></van-tab>
				<van-tab title="5系论坛" name='宝马5系论坛'></van-tab>
				<van-tab title="E级论坛" name='奔驰E级论坛'></van-tab>
				<van-tab title="A4L论坛" name='奥迪A4L论坛'></van-tab>
				<van-tab title="A6L论坛" name='奥迪A6L论坛'></van-tab>
				<van-tab title="C级论坛" name='奔驰C级论坛'></van-tab>
			</van-tabs>
			<van-tabs v-model="activeName" color='#333333' line-width="56px" style="border-bottom: 1px solid #eeeeee;" v-if="RX_tabs" @click="onClick">
				<van-tab title="RX论坛" name='雷克萨斯RX论坛'></van-tab>
				<van-tab title="X3论坛" name='宝马X3论坛'></van-tab>
				<van-tab title="GLC论坛" name='奔驰GLC论坛'></van-tab>
				<van-tab title="" :disabled='true'></van-tab>
			</van-tabs>
			<van-tabs v-model="activeName" color='#333333' line-width="56px" style="border-bottom: 1px solid #eeeeee;" v-if="NX_tabs" @click="onClick">
				<van-tab title="NX论坛" name='雷克萨斯NX论坛'></van-tab>
				<van-tab title="Q5论坛" name='奥迪Q5/Q5L论坛'></van-tab>
				<van-tab title="" :disabled='true'></van-tab>
				<van-tab title="" :disabled='true'></van-tab>
			</van-tabs>
		</div>
		<div class="search_resu">
			<div class="result_title">
				<!-- {{params.key?params.key:bbs_info.name}} -->
				<div class="result_title_flex">
					<div style="flex:1;" >{{params.key?'搜索内容 【'+params.key+'】':bbs_info.name}}</div>
					<div :class="btn_type==1?'choose_btn choose_btn_active':'choose_btn'" @click="chooseBtn(1)">7天</div>
					<div :class="btn_type==2?'choose_btn choose_btn_active':'choose_btn'" @click="chooseBtn(2)">30天</div>
					<div :class="btn_type==3?'choose_btn choose_btn_active':'choose_btn'" @click="chooseBtn(3)">自定义时间</div>
				</div>
				<div class="result_title_flex" v-if="btn_type==3">
					<div style="flex:1;"></div>
					<div class="result_top_time">
						<van-field
						readonly
						clickable
						name="startTime"
						:value="params.start_time"
						placeholder="起始时间"
						@click="showPickerd(1)"
						/>
						至
						<van-field
						readonly
						clickable
						name="endTime"
						:value="params.end_time"
						placeholder="结束时间"
						@click="showPickerd(2)"
						/>
					</div>
					<div class="searchBtn" @click="searchBtn()">查看</div>
				</div>
			</div>

			<div class="result_box">
				<div class="result_box_title">
					<div class="result_left">关联项目</div>
					<div class="result_right">汇总数量</div>
				</div>
				<div class="result_text result_text_active">
					<div class="result_left">关联帖子 ({{params.start_time}}至{{params.end_time.substring(0,10)}})</div>
					<div class="result_right">{{bbs_info.number}}篇</div>
				</div>
				<div class="result_text">
					<div class="result_left">关联评论 ({{params.start_time}}至{{params.end_time.substring(0,10)}})</div>
					<div class="result_right">{{bbs_info.comment_all_num}}条</div>
				</div>
				
			</div>
		</div>
		<div class="search_resu">
			<div class="result_title">关联帖子 ({{params.start_time}}至{{params.end_time.substring(0,10)}})</div>
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-list
				v-model="loading"
				:finished="finished"
				finished-text="已加载全部"
				@load="onLoad"
				>
				<div class="result_box" v-for="item in bbs_list" :key="'list_' + item.id" @click="goBbs(item.id)">
					<div class="result_bbstit">
						<span style="text-decoration: underline;">{{item.name}}</span>
						<img class="result_title_bage" v-if="item.label_two.type==2" :src="img.new">
						<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='1级'" :src="img.level1">
						<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='2级'" :src="img.level2">
						<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='3级'" :src="img.level3">
						<img class="result_title_bage" v-if="item.label.type==3" :src="img.hot">
						<img class="result_title_bage" v-if="item.label.type==4" :src="img.vie">
						<span class="title_tips c_red" v-if="item.user_bbs_type.id>0">[{{item.user_bbs_type.title}}]</span>
						<span class="title_tips c_green" v-if="item.negative_proportion>0&&item.negative_proportion<21">负面评论 {{item.negative_proportion}}%
						</span>
						<span class="title_tips c_blue" v-if="item.negative_proportion>20&&item.negative_proportion<51">负面评论 {{item.negative_proportion}}%
						</span>
						<span class="title_tips c_red" v-if="item.negative_proportion>50&&item.negative_proportion<101">负面评论 {{item.negative_proportion}}%
						</span>
					</div>
					<div class="result_bbstime">
						<div style="flex: 1;">{{item.post_time}}</div>
						<div class="f-r">
							<span>阅读{{item.read_num}}</span>
							<span style="margin-left: 20px;">评论{{item.comment_num}}</span>
						</div>
					</div>

				</div>
			</van-list>
		</van-pull-refresh>
			<!-- <div class="result_box">
				<div class="result_bbstit">雷克萨斯ES新车刚提车出现了一点点问题，从店里行驶出来，忽然从车身后方发出响动……<img class="result_title_bage" :src="img.level1">
				</div>
				<div class="result_bbstime">
					<div style="flex: 1;">2020/10/12 22:30:00</div>
					<div class="f-r">
						<span>阅读236</span>
						<span style="margin-left: 20px;">评论1233</span>
					</div>
				</div>
			</div>
			<div class="result_box">
				<div class="result_bbstit">雷克萨斯ES新车刚提车出现了一点点问题，从店里行驶出来，忽然从车身后方发出响动……<img class="result_title_bage" :src="img.level1"></div>
				<div class="result_bbstime">
					<div style="flex: 1;">2020/10/12 22:30:00</div>
					<div class="f-r">
						<span>阅读236</span>
						<span style="margin-left: 20px;">评论1233</span>
					</div>
				</div>
			</div> -->
		</div>
		<van-popup v-model="showPicker" position="bottom">
			<van-datetime-picker
			v-model="currentDate"
			type="date"
			@confirm="onConfirm"
			@cancel="showPicker = false"
			:max-date="maxDate"
			/>
		</van-popup>
	</div>
</template>

<script>
	import admin from '../../api/admin';
	import { mapState } from 'vuex';
	import { Col, Row,Search,Cell,Toast,DatetimePicker,Field,Popup,Button,Icon,List,PullRefresh,Tab,Tabs } from 'vant';
	export default {
		data () {
			return {
				btn_type:1,
				key:'',
				bbs_type_id:'',
				bbs_info:'',
				bbs_list:[],
				params:{
					page:1,
					start_time:'',
					end_time:''
				},
				loading: false,
				finished: false,
				isLoading:false,
				maxDate:new Date(),
				currentDate: new Date(),
				showPicker:false,
				end_time:'',
				start_time:'',
				ES_tabs:false,
				RX_tabs:false,
				NX_tabs:false,
				active:0,
				list:[],
				listS:[],
				jingpin:false,
				img:{
					hot:require('../../assets/img/hot.png'),
					new: require('../../assets/img/new.png'),
					level1: require('../../assets/img/level1.png'),
					level2: require('../../assets/img/level2.png'),
					level3: require('../../assets/img/level3.png'),
					vie:require('../../assets/img/vie.png')
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user
			})
		},
		watch: {
			'$route'() {
				var myDate = new Date(); //获取系统当前时间
				var date1 = new Date(myDate.getTime()).toLocaleDateString();
				var date2 = new Date(myDate.getTime() - (7 * 24 * 60 * 60 * 1000)).toLocaleDateString();
				var date3 = new Date(myDate.getTime() - (30 * 24 * 60 * 60 * 1000)).toLocaleDateString();
				this.severTime=date2.replace(/\//g,'-')
				this.thereTime=date3.replace(/\//g,'-')
				this.params.type = localStorage.getItem('vie')
				localStorage.removeItem('vie')

				this.getMoreBbs()
				if(localStorage.getItem('bbstype') != this.bbs_type_id) {
					this.params.bbs_type_id = localStorage.getItem('bbstype')
					this.params.key = localStorage.getItem('bbskey')
					this.params.type = localStorage.getItem('vie')
					localStorage.removeItem('vie')
					localStorage.removeItem('bbstype')
					localStorage.removeItem('bbskey')
					if(localStorage.getItem('btn_type')){
						this.btn_type = localStorage.getItem('btn_type')
						if(this.btn_type==3){
							this.params.start_time=localStorage.getItem('start_time')
							this.params.end_time=localStorage.getItem('end_time')
							localStorage.removeItem('start_time')
							localStorage.removeItem('end_time')
						}else{
							this.params.end_time=date1.replace(/\//g,'-')
						}
						localStorage.removeItem('btn_type')
					}else{
						this.params.end_time=date1.replace(/\//g,'-')
					}
					
				}
			}
		},
		created () {
			var myDate = new Date(); //获取系统当前时间
			var date1 = new Date(myDate.getTime()).toLocaleDateString();
			var date2 = new Date(myDate.getTime() - (7 * 24 * 60 * 60 * 1000)).toLocaleDateString();
			var date3 = new Date(myDate.getTime() - (30 * 24 * 60 * 60 * 1000)).toLocaleDateString();
			this.severTime=date2.replace(/\//g,'-')
			this.thereTime=date3.replace(/\//g,'-')
			
			this.params.type = localStorage.getItem('vie')
			localStorage.removeItem('vie')
			this.getMoreBbs()
			this.jingpin = localStorage.getItem('jingpin')
			if(localStorage.getItem('bbstype')){
				this.params.bbs_type_id = localStorage.getItem('bbstype')
				this.params.key = localStorage.getItem('bbskey')
				localStorage.removeItem('bbstype')
				localStorage.removeItem('bbskey')
				if(localStorage.getItem('btn_type')){
					this.btn_type = localStorage.getItem('btn_type')
					if(this.btn_type==3){
						this.params.start_time=localStorage.getItem('start_time')
						this.params.end_time=localStorage.getItem('end_time')
						localStorage.removeItem('start_time')
						localStorage.removeItem('end_time')
					}else{
						this.params.end_time=date1.replace(/\//g,'-')
					}
					localStorage.removeItem('btn_type')
				}else{
					this.params.end_time=date1.replace(/\//g,'-')
				}
			}
		},
		methods: {
			// getInfo(){
			// 	var params={
			// 		key:this.key,
			// 		bbs_type_id:this.bbs_type_id
			// 	}
			// 	admin.getAdminBbsinfo(params).then(res => {
			// 		if(res.data.state==1){
			// 			this.info=res.data.data
			// 			this.bbs_info=res.data.data.bbs_info
			// 			this.bbs_list=res.data.data.bbs_list
			// 			if(this.key){
			// 				this.$util.title(res.data.data.bbs_info.name)
			// 			}
			// 		}else{

			// 		}

			// 	})
			// },
			getMoreBbs(){
				var params={
					start_time:this.thereTime,
					end_time:this.end_time,
					type:2
				}
				admin.getMoreBbs(params).then(res => {
					if(res.data.state==1){
						this.list=res.data.data.bbs_type_list
					}
				})
				var paramsD={
					start_time:this.thereTime,
					end_time:this.end_time
				}
				admin.getMoreBbs(paramsD).then(res => {
					if(res.data.state==1){
						this.listS=res.data.data.bbs_type_list
					}
				})
			},
			onClick(name,title){
				this.activeName=name
				var list=this.list
				var listS=this.listS
				var bbs_type_id=this.params.bbs_type_id
				if(name=='雷克萨斯ES论坛'||name=='雷克萨斯RX论坛'||name=='雷克萨斯NX论坛'){
					for (var i = 0;i<listS.length;i++) {
						if(name==listS[i].name){
							this.params.page=1
							this.params.bbs_type_id=listS[i].type
							this.finished = false
							this.bbs_list=[]
							this.onLoad()
						}
					}
				}else{
					for (var i = 0;i<list.length;i++) {
						if(name==list[i].name){
							this.params.page=1
							this.params.bbs_type_id=list[i].type
							this.finished = false
							this.bbs_list=[]
							this.onLoad()
						}
					}
				}
				
			},
			goBbs(id){
				localStorage.setItem('bbsid', id)
				wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=bbsinfo'})
			},
			onRefresh() {
				setTimeout(() => {
					this.isLoading = false;
				}, 1000);
				this.bbs_list=[]
				this.params.page = 1
				this.finished = false
				this.onLoad()
			},
			showPickerd(num){
				this.timeField=num
				this.showPicker=true
			},
			onConfirm(time) {
				var Y = time.getFullYear();
				var M = time.getMonth() + 1;
				M = M < 10 ? '0' + M : M;
				var D = time.getDate();
				D = D < 10 ? '0' + D : D;
				var H = time.getHours();
				H = H < 10 ? '0' + H : H;
				var Mi = time.getMinutes();
				Mi = Mi < 10 ? '0' + Mi : Mi;
				var S = time.getSeconds();
				S = S < 10 ? '0' + S : S;

				this.showPickertime = false;
				if(this.timeField==1){
					this.params.start_time=Y + '-' + M + '-' + D
				}else{
					this.params.end_time=Y + '-' + M + '-' + D
					this.params.page=1
					this.bbs_list=[]
					this.finished = false
					this.onLoad()
				}
				this.showPicker = false;
			},
			chooseBtn(type){
				this.btn_type=type
				this.params.page=1
				this.bbs_list=[]
				this.finished = false
				if(type!=3){
					this.onLoad()
				}else{
					this.params.start_time=''
					this.params.end_time=''
				}
				
			},
			searchBtn(){
				this.params.page=1
				this.finished = false
				this.bbs_list=[]
				this.onLoad()
			},
			onLoad(){
				setTimeout(() => {
					if(this.btn_type==1){
						var start_time=this.severTime
						this.params.start_time=this.severTime
					}else if(this.btn_type==2){
						var start_time=this.thereTime
						this.params.start_time=this.thereTime
					}else if(this.btn_type==3){
						var start_time=this.params.start_time
					}
					this.params.end_time=this.params.end_time
					admin.getAdminBbsinfo(this.params).then(res => {
						if(res.data.state==1){
							this.info=res.data.data
							this.bbs_info=res.data.data.bbs_info
							this.activeName=res.data.data.bbs_info.name
							if(res.data.data.bbs_info.name=='雷克萨斯ES论坛'||res.data.data.bbs_info.name=='宝马3系论坛'||res.data.data.bbs_info.name=='奔驰C级论坛'||res.data.data.bbs_info.name=='奥迪A4L论坛'||res.data.data.bbs_info.name=='宝马5系论坛'||res.data.data.bbs_info.name=='奔驰E级论坛'||res.data.data.bbs_info.name=='奥迪A6L论坛'){
								this.ES_tabs=true
							}else if(res.data.data.bbs_info.name=='雷克萨斯RX论坛'||res.data.data.bbs_info.name=='宝马X3论坛'||res.data.data.bbs_info.name=='奔驰GLC论坛'){
								this.RX_tabs=true
							}else if(res.data.data.bbs_info.name=='雷克萨斯NX论坛'||res.data.data.bbs_info.name=='奥迪Q5/Q5L论坛'){
								this.NX_tabs=true
							}
							this.bbs_list.push.apply(this.bbs_list, res.data.data.bbs_list)
							if(this.params.key){
								this.$util.title(res.data.data.bbs_info.name)
							}
							this.params.page += 1
							this.loading = false

							if(res.data.data.bbs_list.length == 0) {
								this.finished = true
							}
						}else{

						}

					})
				}, 500);
			}

		},
		components: {
			[Col.name]: Col,
			[Row.name]: Row,
			[Search.name]:Search,
			[Cell.name]:Cell,
			[Toast.name]:Toast,
			[DatetimePicker.name]:DatetimePicker,
			[Field.name]:Field,
			[Popup.name]:Popup,
			[Button.name]:Button,
			[Icon.name]:Icon,
			[PullRefresh.name]:PullRefresh,
			[List.name]: List,
			[Tabs.name]:Tabs,
			[Tab.name]:Tab
		}
	}
</script>
<style lang="scss">
	.keywordwarninginfo{
		padding: 15px;
		.result_title{
			font-size: 14px;
			margin-top: 15px;
			padding-bottom:10px;
			border-bottom: 1px solid #EEEEEE;

			.result_title_flex{
				display: flex;
				align-items:center;
				margin-top: 10px;
			}
			.result_top_time{
				border-radius:4px;
				border:1px solid #BBBBBB;
				display: flex;
				align-items:center;
				font-size: 10px;

				float: right;
				width: 200px;
				.time_left{
					flex: 1;
				}
				.van-field{
					margin: 0 5px;
					font-size: 10px;
				}
				.van-cell{
					padding:3px 5px;
					width: 50%;
					.van-field__control{
						text-align: center;
					}
				}
				.van-button{
					height: 36px;
					line-height: 0;
				}

			}
			.searchBtn{
				color: #fff;
				margin-left: 10px;
				padding:5px 10px;
				border-radius:4px;
				background-color:#333333;
			}
			.choose_btn{
				border:1px solid #666666;
				color: #666666;
				font-size: 10px;
				border-radius:4px;
				padding:3px 10px;
				margin-left: 5px;
			}
			.choose_btn_active{
				background-color:#BBBBBB;
			}
		}
		.search_resu{
			margin-top: 20px;
			.result_box{
				font-size: 12px;
				padding:10px;
				margin-top: 15px;
				border:1px solid #BBBBBB;
				border-radius:4px;
				.result_box_title{
					display: flex;
					align-items:center;
					border-bottom:1px solid #EEEEEE;
					padding:0 10px 10px 10px;
					margin-bottom: 10px;
				}
				.result_text{
					display: flex;
					align-items:center;
					padding:10px 10px;
				}
				.result_text_active{
					background-color:#F8F8F8;
				}
				.result_left{
					flex: 1;
				}
				.result_right{
					float: right;
				}
				.result_bbstit{
					color: #333333;
					font-size: 12px;
					border-bottom:1px solid #EEEEEE;
					padding-bottom:10px;
				}
				.result_title_bage{
					width: 36px;
					height: 16px;
					vertical-align:middle;
					margin-left: 10px;
				}
				.title_tips{
					font-size:12px;
					margin-left: 10px;
					display:inline-block;
				}
				.c_red{
					color: #f90303;
				}
				.c_green{
					color: #1aad19;
				}
				.c_blue{
					color: #0037ff;
				}
				.result_bbstime{
					color: #999999;
					font-size: 12px;
					padding-top:10px;
					display: flex;
					align-items:center;
				}
			}
			.keyword_box{
				border: 1px solid #BBBBBB;
				border-radius: 4px;
				font-size:12px;
			}
		}
		.van-tabs__wrap--scrollable .van-tabs__nav--complete{
			padding-right:0;
			padding-left:0;
		}
	}

</style>